export const checkCameraAuthenticity = async (stream) => {
    if (!stream) return false;

    try {
        const videoTrack = stream.getVideoTracks()[0];
        if (!videoTrack) return false;

        const settings = videoTrack.getSettings();
        const capabilities = videoTrack.getCapabilities ? videoTrack.getCapabilities() : {};

        const virtualIndicators = [
            !settings.deviceId || settings.deviceId === '',
            settings.label && (
                settings.label.toLowerCase().includes('obs') ||
                settings.label.toLowerCase().includes('virtual') ||
                settings.label.toLowerCase().includes('snap') ||
                settings.label.toLowerCase().includes('manycam') ||
                settings.label.toLowerCase().includes('screen')
            ),
            !capabilities.facingMode,
            settings.width === 1920 && settings.height === 1080,
        ];

        const suspiciousCount = virtualIndicators.filter(Boolean).length;
        return suspiciousCount >= 2;
    } catch (error) {
        console.error('Error checking camera authenticity:', error);
        return false;
    }
};

export const isVirtualCamera = async (deviceId) => {
    try {
        const stream = await navigator.mediaDevices.getUserMedia({
            video: { deviceId: { exact: deviceId } }
        });

        const isVirtual = await checkCameraAuthenticity(stream);
        
        stream.getTracks().forEach(track => track.stop());
        
        return isVirtual;
    } catch (error) {
        console.error('Error checking if camera is virtual:', error);
        return false;
    }
};

export const detectVirtualCameras = async () => {
    try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(device => device.kind === 'videoinput');
        
        const virtualCameras = [];
        
        for (const device of videoDevices) {
            const isVirtual = await isVirtualCamera(device.deviceId);
            if (isVirtual) {
                virtualCameras.push(device);
            }
        }
        
        return virtualCameras;
    } catch (error) {
        console.error('Error detecting virtual cameras:', error);
        return [];
    }
};
